module.exports = __webpack_public_path__ + "static/1 (9)-965702a68cc92fca5849220695859643.png";